import type { DocumentType, MemberStatus, ProofType } from "../services/types";

export const PROOF_TYPES: { value: ProofType; label: string }[] = [
  { value: "aadhaar", label: "Aadhaar" },
  { value: "pan", label: "PAN" },
  { value: "voter", label: "Voter ID" },
  { value: "driving", label: "Driving Licence" },
  { value: "passport", label: "Passport" },
];

export const DOCUMENT_TYPES: { value: DocumentType; label: string }[] = [
  ...PROOF_TYPES,
  { value: "photo", label: "Photograph" },
  { value: "address", label: "Address Proof" },
  { value: "other", label: "Other" },
];

export const MEMBER_STATUSES: { value: MemberStatus; label: string }[] = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "blacklisted", label: "Blacklisted" },
];

export const PROOF_LABEL: Record<ProofType, string> = {
  aadhaar: "Aadhaar",
  pan: "PAN",
  voter: "Voter ID",
  driving: "Driving Licence",
  passport: "Passport",
};

export const DOC_TYPE_LABEL: Record<DocumentType, string> = {
  aadhaar: "Aadhaar",
  pan: "PAN",
  voter: "Voter ID",
  driving: "Driving Licence",
  passport: "Passport",
  photo: "Photograph",
  address: "Address Proof",
  other: "Other",
};

export const STATUS_LABEL: Record<MemberStatus, string> = {
  active: "Active",
  inactive: "Inactive",
  blacklisted: "Blacklisted",
};

import type { BadgeVariant } from "../components/base/Badge";

export const STATUS_BADGE: Record<MemberStatus, BadgeVariant> = {
  active: "active",
  inactive: "inactive",
  blacklisted: "cancelled",
};